export const IIM_REVIEW_COMPLETED_EVENT = 'iimReviewCompleted';
export const IIM_RUN_COMPLETED_EVENT = 'iimRunCompleted';
export const IIM_BUCKET_FILTER_EVENT = 'iim:bucketFilter';
